import axios from "axios";
import { sto } from "../../Context/InshData";
import { uri } from "../../help/Api";

export const localSearchAccount = (newValue, accounts,setSearchAccountText) => {
    const search = newValue?.trim().toLowerCase();
    setSearchAccountText(newValue);
    return accounts.filter((obj) => obj?.name.toLowerCase().includes(search) ||  String(obj?.id).toLowerCase().includes(search));
};
export const handleSearchAccount = (newValue, accounts, searchTimeout, setAccountsOptions, 
    countAccounts,setSearchAccountText,reason) => {
    if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
    }
    if (!newValue || newValue.length < 1 || reason !== "input") {
        setAccountsOptions(accounts);
        return;
    }
    searchTimeout.current = setTimeout(async () => {
        const opLocAccounts = localSearchAccount(newValue, accounts,setSearchAccountText);
        if (opLocAccounts.length > 0) {
            setAccountsOptions(opLocAccounts ?? []);
            return;
        } else if (countAccounts) {
            viewHandleAccounts(newValue, setAccountsOptions,-1); 
        } else {
            setAccountsOptions([]);
        }
    }, 500);
};

export const viewHandleAccounts = (newValue,setAccountsOptions,acc_no,valueAcc,accounts) => {
    const tb = {
        AccountsIndex: true,
        parms: {
            cust_id:acc_no,
            cust_name: newValue,
            tname: "search",
            iempid: sto.empi,
            withOmlat : false,
            db_name:sto?.db_name,
        },
    };
    axios
        .post(uri + "GetD", tb)
        .then((res) => {
            if (acc_no!=-1){valueAcc=res.data?.Accindex[0];
                setAccountsOptions([...res.data?.Accindex,...accounts]);
            }else{ setAccountsOptions(res.data?.Accindex);}
        })
        .catch((error) => {
            setAccountsOptions([]);
        });
};